import { CanDeactivateFn } from "@angular/router";
import { DspBlacklistComponent } from "@m19-board/dsp/dsp-blacklist/dsp-blacklist/dsp-blacklist.component";

export const dspBlacklistSaveGuard: CanDeactivateFn<DspBlacklistComponent> = (component) => {
  if (component.hasChanged()) {
    return component.openUnsavedChangesWarningModal();
  }
  return true;
};
